import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Box, FormHelperText } from '@mui/material';
import { useEffect } from 'react';
// Wrap SDatepicker with forwardRef to accept refs
const SDatePicker = React.forwardRef(({ value, label, disabled = false, onChange, errormsg, size = 'medium', variant = 'outline', disablePast, timeOfDay = 'start', minDate }, ref) => {
    const [dateValue, setDateValue] = React.useState(value ? dayjs(value) : null);
    const handleDateChange = (newValue) => {
        if (newValue) {
            var parsedDate = timeOfDay === 'start'
                ? dayjs(newValue?.startOf('day')) // Will set the time to 00:00:00
                : dayjs(newValue?.endOf('day'));
            setDateValue(parsedDate);
            onChange?.(parsedDate?.toDate());
        }
        else {
            setDateValue(newValue);
            onChange?.(newValue);
        }
    };
    useEffect(() => {
        setDateValue(value ? dayjs(value) : null);
    }, [value]);
    return (_jsxs(Box, { width: '100%', children: [_jsx(LocalizationProvider, { dateAdapter: AdapterDayjs, children: _jsx(DatePicker, { minDate: minDate, disabled: disabled, label: label ? label : undefined, sx: { width: '100%' }, format: 'DD/MM/YYYY', value: dateValue, onChange: handleDateChange, disablePast: disablePast, ref: ref, slotProps: {
                        textField: {
                            size,
                            sx: {
                                width: '100%',
                                background: variant === 'contained' ? '#919EAB14' : '',
                                border: 'none'
                            },
                            error: !!errormsg
                        }
                    } }) }), _jsx(FormHelperText, { error: true, children: errormsg?.trim() })] }));
});
export default SDatePicker;
